import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import AttivaCard from '../../../components/card/AttivaCard';
import useFetch from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { LeadsService } from '../../../services/leads/leadsService';
import LeadForm from '../LeadForm';

const pageHeader = {
    title: 'Editar Renovación',
    breadcrumb: [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { href: menuRoutes.leads.path, name: 'Renovaciones', },
        { name: 'Editar Renovación' },
    ],
};

export default function LeadEdit() {

    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState<boolean>(false);

    const [data, isLoading] = useFetch(() => (new LeadsService()).getLead(id!));

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = await (await (new LeadsService()).editLead(values)).getResponseData();
            if (response.success) {
                setLoading(false);
                navigate(-1);
                setTimeout(() => { toast.success('Renovación editada correctamente') }, 100);
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error('Error al editar la renovación');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title='Datos Principales'>
                <LeadForm submit={handleSubmit} isLoading={loading || isLoading} data={data} />
            </AttivaCard>
        </>
    );
}